/**
 * Panel definitions for forward/gas commodity
 * Add your gas-related panels here based on backend dataset configs
 */
export const forwardGasPanels = [
  // First row: 2 panels side-by-side (12 cols each)
  {
    id: 'cals-ttf',
    type: 'datasetChart',
    datasetId: 'ice-cals-ttf-gas',
    visualizationId: 'cals-ttf-gas-forward-curve',
    labelOverrides: { descriptionKey: 'dashboard_panels.gas_forward_curve' },
    gridPos: { x: 0, y: 0, w: 12, h: 15 },
  },
  {
    id: 'live-ttf',
    type: 'datasetChart',
    datasetId: 'eex-gas-spot-intraday',
    visualizationId: 'eex-gas-spot-intraday-chart',
    gridPos: { x: 12, y: 0, w: 12, h: 15 },
  },
  // Second row: 2 panels side-by-side (12 cols each)
  {
    id: 'cals-ttf-fronth-month',
    type: 'datasetChart',
    datasetId: 'ice-cals-ttf-gas',
    visualizationId: 'cals-ttf-gas-front-month-daily',
    gridPos: { x: 0, y: 15, w: 12, h: 15 },
  },
  {
    id: 'cals-ttf-monthly-settlements',
    type: 'datasetChart',
    datasetId: 'ice-cals-ttf-gas',
    visualizationId: 'cals-ttf-gas-monthly-settlements',
    gridPos: { x: 12, y: 15, w: 12, h: 15 },
  },
  // Third row: 2 panels side-by-side (12 cols each) (right is placeholder for now)
  {
    id: 'gas-in-storage',
    type: 'datasetChart',
    datasetId: 'gie-gas-storage',
    visualizationId: 'gie-gas-storage-gas-in-storage-yoy',
    labelOverrides: { descriptionKey: 'dashboard_panels.gas_in_storage_yoy' },
    gridPos: { x: 0, y: 30, w: 12, h: 15 },
  },
  {
    id: 'gas-prices-world',
    type: 'datasetWorldMap',
    datasetId: 'profiteia-gas-prices',
    visualizationId: 'multi-gas-prices-gas-price-eur-mwh',
    gridPos: { x: 12, y: 30, w: 12, h: 15 },
  },
  // Fourth row: 2 panels side-by-side
  {
    id: 'ice-nwe-lng-futures',
    type: 'datasetChart',
    datasetId: 'ice-nwe-lng',
    visualizationId: 'ice-nwe-lng-forward-curve',
    gridPos: { x: 0, y: 45, w: 12, h: 15 },
  },
  {
    id: 'ice-nwe-lng-monthly-settlements',
    type: 'datasetChart',
    datasetId: 'ice-nwe-lng',
    visualizationId: 'ice-nwe-lng-monthly-settlements',
    gridPos: { x: 12, y: 45, w: 12, h: 15 },
  },
  // Fifth row: ICE SWE LNG panels
  {
    id: 'ice-swe-lng-futures',
    type: 'datasetChart',
    datasetId: 'ice-swe-lng',
    visualizationId: 'ice-swe-lng-forward-curve',
    gridPos: { x: 0, y: 60, w: 12, h: 15 },
  },
  {
    id: 'ice-swe-lng-monthly-settlements',
    type: 'datasetChart',
    datasetId: 'ice-swe-lng',
    visualizationId: 'ice-swe-lng-monthly-settlements',
    gridPos: { x: 12, y: 60, w: 12, h: 15 },
  },
  // Sixth row: LNG Carrier Tracker (full width)
  {
    id: 'lng-carrier-tracker',
    type: 'lngCarrierMap',
    gridPos: { x: 0, y: 75, w: 24, h: 20 },
  },
  // Seventh row: Gas Balance Sankey (full width)
  {
    id: 'gas-balance-sankey',
    type: 'gasBalanceSankey',
    datasetId: 'entsog-gas-balance',
    visualizationId: 'gas-balance-sankey',
    gridPos: { x: 0, y: 95, w: 24, h: 20 },
  },
  // Eighth row: Cross-Border Gas Flow Map (full width)
  {
    id: 'entsog-gas-crossborder-flows',
    type: 'gasFlowMap',
    datasetId: 'entsog-gas-crossborder-flows',
    visualizationId: 'gas-crossborder-flows-flow-map',
    gridPos: { x: 0, y: 115, w: 24, h: 20 },
  },
  {
    id: 'gas-power-calendar-comparison',
    type: 'datasetChart',
    datasetId: 'ice-cals-ttf-gas',
    visualizationId: 'cals-ttf-gas-power-calendar-comparison',
    labelOverrides: { descriptionKey: 'dashboard_panels.gas_power_calendar_comparison' },
    gridPos: { x: 0, y: 135, w: 24, h: 15 },
  },
];

export const forwardGasSyncGroups = [
  {
    id: 'gas-row-1',
    global: false,
    ids: ['cals-ttf', 'live-ttf'],
    syncAxes: { y: true },
  },
  {
    id: 'gas-row-2',
    global: false,
    ids: ['cals-ttf-fronth-month', 'cals-ttf-monthly-settlements'],
    syncAxes: { y: true },
  },
  {
    id: 'gas-row-4',
    global: false,
    ids: ['ice-nwe-lng-futures', 'ice-nwe-lng-monthly-settlements'],
    syncAxes: { y: true },
  },
  {
    id: 'gas-row-5',
    global: false,
    ids: ['ice-swe-lng-futures', 'ice-swe-lng-monthly-settlements'],
    syncAxes: { y: true },
  },
];
